module.exports = __webpack_public_path__ + "static/media/image012.de296e52.jpg";